import classes from "./RecipeHeader.module.css";


// component for header of recipe card
const RecipeHeader = (props) => {
  return (
    <div className={classes.recipe_header}>
      <div className={classes.drink_title}>{props.title}</div>
    </div>
  );
};

export default RecipeHeader;
